import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var segmentedControl = createRuntimeFn({defaultClassName:'fx_c76f37be_1ubl9638',variantClassNames:{fullWidth:{true:'fx_c76f37be_1ubl9639',false:'fx_c76f37be_1ubl963a'},size:{xsmall:'fx_c76f37be_1ubl963b',small:'fx_c76f37be_1ubl963c','default':'fx_c76f37be_1ubl963d',large:'fx_c76f37be_1ubl963e'}},defaultVariants:{fullWidth:false,size:'default'},compoundVariants:[]});

export { segmentedControl };
//# sourceMappingURL=segmentedControl.vanilla.mjs.map
